import { Injectable } from '@angular/core';
import { NewAuthTokenResponse } from '@app/core/auth/interfaces/new-access-token-response';
import { UploadedFileBase } from '@app/entities/files/interfaces/uploaded-file-base';
import { FilesService } from '@app/entities/files/services/files.service';
import { User } from '@app/entities/users/interfaces/user';
import { UsersService } from '@app/entities/users/services/users.service';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { SaveAuthTokens } from '../auth';
import { ProfileStateModel } from './profile-state.model';
import { LoadProfile, UpdateProfile, UploadAvatar } from './profile.actions';

@State<ProfileStateModel>({
  name: 'profile',
})
@Injectable()
export class ProfileState {
  constructor(
    private usersService: UsersService,
    private filesService: FilesService,
    private store: Store,
  ) {}

  @Action(LoadProfile)
  @ImmutableContext()
  loadProfile({ setState }: StateContext<ProfileStateModel>) {
    return this.usersService.getProfile().pipe(
      tap((user: User) => {
        return setState((state: ProfileStateModel) => {
          state.user = user;

          return state;
        });
      }),
    );
  }

  @Action(UpdateProfile)
  @ImmutableContext()
  updateProfile(
    { setState }: StateContext<ProfileStateModel>,
    { data }: UpdateProfile,
  ) {
    return this.usersService.updateProfile(data).pipe(
      tap((tokens: NewAuthTokenResponse) => {
        return setState((state: ProfileStateModel) => {
          this.store.dispatch(new SaveAuthTokens(tokens));
          return state;
        });
      }),
    );
  }

  @Action(UploadAvatar)
  @ImmutableContext()
  uploadAvatar(
    { setState }: StateContext<ProfileStateModel>,
    { data }: UploadAvatar,
  ) {
    return this.filesService.uploadFile(data).pipe(
      tap((uploadedFile: UploadedFileBase) => {
        return setState((state: ProfileStateModel) => {
          state.user!.profile.avatar = uploadedFile;

          return state;
        });
      }),
    );
  }
}
